import type { ShouldRevalidateFunctionArgs } from 'react-router';

/**
 * Shared shouldRevalidate function for routes that should not revalidate
 * when add-to-cart submissions occur. This prevents unnecessary data refetching
 * when users add items to their cart.
 */
export const productGridShouldRevalidate = ({
  defaultShouldRevalidate,
  formAction,
}: ShouldRevalidateFunctionArgs) => {
  // Don't revalidate on add-to-cart submissions
  if (formAction?.includes('cart')) {
    return false;
  }

  return defaultShouldRevalidate;
};
